import type { OperationResult } from 'venn-api';

export const isRequestSuccessful = (request: OperationResult<unknown>) => request.status >= 200 && request.status < 400;

export default isRequestSuccessful;
